import { Flex, Skeleton } from '@eqi-investimentos/react';

export const MenuSkeleton = () => {
  return (
    <Flex
      alignItems="center"
      w="full"
      gap="2xs"
      py="2xl"
      borderBottomWidth="0.0625rem"
      borderBottomColor="transparency.light"
      overflow="hidden"
    >
      {Array.from({ length: 6 }).map((_, i) => (
        <Flex
          key={`menu-skeleton-${i}`}
          flex={1}
          flexDir="column"
          alignItems="center"
          gap="s"
          py="m"
          px="xs"
          w="fit-content"
        >
          <Skeleton boxSize="2rem" borderRadius="full" />
          <Skeleton w="6.75rem" h="1rem" />
        </Flex>
      ))}
    </Flex>
  );
};
